import { toast } from '@/components/UI/Toast';
import { useSwitchCompany } from '@/features/user-management';
import { startAdditionalCompanyRegistration } from '@/http/Company/CompanyUserApi';
import { useState } from 'react';

/**
 * Starts registering an additional company for the signed-in user and switches into it.
 * Shared by the user menu's "Add new company" item and the QA Playground walkthrough rail's
 * "New Company Sign-Up" step (#9141), so both run exactly the same real flow.
 */
const useAddNewCompany = () => {
  const [isStarting, setIsStarting] = useState(false);
  const switchCompany = useSwitchCompany();

  const start = async () => {
    setIsStarting(true);
    try {
      const newCompanyId = await startAdditionalCompanyRegistration();
      switchCompany.mutate({ companyId: newCompanyId });
    } catch (error) {
      // Stay put. Do NOT navigate to /registration with the old JWT context —
      // the wizard would read/write against the user's previous company.
      toast({
        color: 'danger',
        title: 'Could not start a new company registration. Please try again.'
      });
      console.error('handleAddNewCompany failed', error);
    } finally {
      setIsStarting(false);
    }
  };

  return { start, isStarting };
};

export default useAddNewCompany;
